import React from 'react'
import '../Css/styles2.css'
import '../Css/bootstrap.css'
import { about3 } from './images'

function AboutUs() {
    return (
        <div className='marginAboutUs'>
            <div className="container-fluid py-5 my-5">
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-lg-5 col-md-6 col-sm-12 wow fadeIn" data-wow-delay=".3s">
                            <div className="h-100 position-relative">
                                <img src="images/about-1.jpg" className="img-fluid w-75 rounded" alt="" style={{ marginBottom: '20%' }} />
                                <div className="position-absolute w-75" style={{ top: '20%', left: '12%' }}>
                                    <img src="images/about-2.jpg" className="img-fluid w-100 rounded" alt="" />
                                </div>
                                <div className="position-absolute w-75" style={{ top: '35%', left: '25%' }}>
                                    <img src={about3} className="img-fluid w-100 rounded" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-6 col-sm-12 wow fadeIn" data-wow-delay=".5s">
                            <h5 className="text-primary">About Us</h5>
                            <h1 className="mb-4">About UPSYS - IT and Marketing Solutions</h1>
                            <p>Welcome to UPSYS, a dynamic startup organization committed to revolutionizing the
                                way solutions are delivered. With a passion for efficiency and an unwavering
                                commitment to quality, we are your partners in achieving your goals, swiftly and
                                effectively. At UPSYS, we believe that time is of the essence, and that's why we
                                specialize in providing perfect solutions in record time, without compromising on the
                                excellence you deserve.</p>
                            <p className="mb-4">Our vision at UPSYS is simple yet powerful: to be the forefront of innovation,
                                offering
                                unparalleled solutions that exceed expectations. We aim to redefine the standard of
                                service delivery by combining speed, precision, and expertise to create an
                                exceptional experience for every client we work with.</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AboutUs